import FilterForm from 'components/forms/FilterForm';
import { DatePicker, Form, FormProps, Input, Select } from 'antd';
import { IFilter } from '../list';

export interface ForumReportsFilterProps {
  searchFormProps: FormProps<IFilter>;
}

export const ForumReportsFilter = ({
  searchFormProps
}: ForumReportsFilterProps) => {
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="category">
        <Select placeholder="Categoria..." allowClear>
          <Select.Option value="spam">
            Conteúdo comercial indesejado ou spam
          </Select.Option>
          <Select.Option value="offensive">
            Discurso de ódio ou violência explícita
          </Select.Option>
          <Select.Option value="harassment">Assédio ou bullying</Select.Option>
          <Select.Option value="misinformation">Desinformação</Select.Option>
          <Select.Option value="other">Outro</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item name="author">
        <Input placeholder="Autor" />
      </Form.Item>

      <Form.Item name="moderator">
        <Input placeholder="Moderador" />
      </Form.Item>

      <Form.Item name="startsAt">
        <DatePicker
          className="w-full"
          placeholder="Data da denúncia (início)"
          format="DD/MM/YYYY"
        />
      </Form.Item>

      <Form.Item name="endsAt">
        <DatePicker
          className="w-full"
          placeholder="Data da denúncia (término)"
          format="DD/MM/YYYY"
        />
      </Form.Item>

      <Form.Item name="status">
        <Select placeholder="Status" defaultValue={null}>
          <Select.Option>Todos status</Select.Option>
          <Select.Option key="pending">Pendende</Select.Option>
          <Select.Option key="accepted">Aceito</Select.Option>
          <Select.Option key="rejected">Rejeitado</Select.Option>
        </Select>
      </Form.Item>
    </FilterForm>
  );
};
